import _ from 'lodash'
import empty from 'is-empty'
let mutations = {
  pushComment (state, value) {
    state.commentList.push(value)
  },
  cloneComment (state, value) {
    state.commentList = _.cloneDeep(value)
  },
  updateComment (state, value) {
    var index = state.commentList.findIndex(x => x.regDate === value.regDate)
    if (index !== -1) {
      delete value.__typename
      value.replyFlag = 0
      value.replyContents = ''
      state.commentList[index] = _.cloneDeep(value)
    }
  },
  getBasketCnt (state, value) {
    var data = JSON.parse(value)
    if (!empty(data)) {
      state.basketCnt = data.length
    } else {
      state.basketCnt = 0
    }
  },
  deleteAddress (state, value) {
    var index = state.addressList.findIndex(x => x.DELIVERY_SEQ === value.DELIVERY_SEQ)
    if (index !== -1) {
      state.addressList.splice(index, 1)
    }
  },
  pushStoreDeliveryInfo (state, value) {
    state.storeDeliveryInfo.push(value)
  },
  setUpdateAddrFlag (state, value) {
    state.updateAddrFlag = value
  },
  resetUpdateAddrData (state) {
    state.preUpdateAddr = {}
  },
  getUpdateAddrData (state, value) {
    state.preUpdateAddr = _.cloneDeep(value)
  },
  setEventSeq (state, value) {
    state.eventSeq = value
  },
  setKey (state, value) {
    state.key = value
  },
  setStoreInfo (state, obj) {
    state.storeInfo = obj
  },
  setTitle (state, value) {
    state.title = value
  },
  setIsLoading (state, value) {
    state.isLoading = value
  },
  setCustomerPhone (state, value) {
    state.customerPhone = value
  },
  setAppTotalDiscount (state, value) {
    state.appTotalDiscount = value
  },
  setKakao (state, value) {
    state.kakao = value
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js